import React from "react";
import ReactDOM from "react-dom/client";
import "@user27828/shared-utils/client/init";
import _ from "lodash";
import { optionsManager, log } from "@user27828/shared-utils/utils";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { isDev } from "@smfa/utils/src";
import "../src/styles/bootstrap.min.css";
import "../src/styles/animate.css";
import "../src/styles/meanmenu.css";
import "../src/styles/boxicons.min.css";
import "../src/styles/flaticon.css";

import "react-accessible-accordion/dist/fancy-example.css";
import "react-datepicker/dist/react-datepicker.css";
// Global Styles
import "../src/styles/style.css";
import "../src/styles/responsive.css";
import "./styles/custom.css";
import { initializeSession } from "@smfa/utils/src";

/* eslint-disable no-undef */
globalThis.log = log; // Make log utility available globally
if (isDev) {
  globalThis._ = _; // Make lodash available globally
}
/* eslint-enable no-undef */

// Initialize global logging with custom options
optionsManager.setGlobalOptions({
  log: {
    type: "client",
    client: {
      namespace: "SMFA",
      production: ["error"], // Only show warnings and errors in prod
    },
  },
  turnstile: {
    siteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
    environment: process.env.NODE_ENV,
  },
});

// Root component with improved persistence handling
const Root = () => {
  return (
    <Provider store={store}>
      <PersistGate
        loading={<div>Loading...</div>}
        persistor={persistor}
        onBeforeLift={() => initializeSession({ dispatch: store.dispatch })}
      >
        <App />
      </PersistGate>
    </Provider>
  );
};

// Render the app
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);

// Diagnostics listener for hydration issues
if (process.env.NODE_ENV !== "production") {
  // Monitor state changes
  store.subscribe(() => {
    const state = store.getState();
    log.debug("Redux state updated:", state);

    // Check for auth-related state issues
    if (state.auth) {
      log.debug("Auth state check:", {
        isAuthenticated: state.auth.isAuthenticated,
        hasUserdata:
          !!state.auth.user && Object.keys(state.auth.user).length > 0,
      });
    }
  });
}
